interface CopyConfig {
    notExisting?: boolean,
    onlyExisting?: boolean,
    newObject?: boolean
}

/**
 * [Impure] Copy property values from one object into another and return the result.
 * @param toObj - Object to copy properties in to.
 * @param fromObj - Object to copy properties from.
 * @param config - Optional configuration properties { onlyExisting, notExisting, newObject }.
 */
export function copy(toObj: any, fromObj: any, config?: CopyConfig): any {
    config = config || {};
    const { notExisting, onlyExisting, newObject } = config;                // Alias config properties.
    if (newObject) toObj = copy({}, toObj);                                 // If passed "newObject", create new object copy of "to" object.
    Object.keys(fromObj).forEach(key => {                                   // Iterate over all keys on "from" obj.
        if (notExisting && toObj[key] !== undefined) return;                // If passed "notExisting", only copy properties "to" object doesn't have.
        if (onlyExisting && toObj[key] === undefined) return;               // If passed "onlyExisting", only copy properties "to" object already has.
        if (toObj[key] instanceof Object) copy(toObj[key], fromObj[key]);   // If "to" obj value at that key is an object, recurse on that object.
        else toObj[key] = fromObj[key];                                     // Otherwise set "to" obj value equal to "from" obj value.
    });
    return toObj;                                                           // Return "to" object.
}
